import { NgModule, APP_INITIALIZER } from '@angular/core';
import {
  FocusOnEscapeDirective,
  TabFocusOnIndividualCheckboxDirective,
  TableFocusCheckboxShortcutDirective,
  PaginatorKeyCombinationDirective,
  PaginatorNavigationDirective,
  IconClickShortcutDirective,
  FocusOnShortcutDirective,
  AccordionExpandCollapseDirective,
  TabShortcutDirective,
  OpenPopupShortcutDirective,
  OpenDetailsShortcutDirective,
  HawbShortcutDirective,
  SortShortcutDirective,
  TabNoOnlyShortcutDirective,
  ApArChargeGridAddShortcutDirective,
} from './keystroke.directive';
import { AppEnterSubmitDirective } from './enter-submit.directive';
import { PaginatorArrowWindowRegistryService } from '../../services/paginator-arrow-window-registry.service';

function initPaginatorArrowWindowCapture(
  _registry: PaginatorArrowWindowRegistryService
): () => void {
  return () => undefined;
}

@NgModule({
  declarations: [
    FocusOnEscapeDirective,
    TabFocusOnIndividualCheckboxDirective,
    TableFocusCheckboxShortcutDirective,
    PaginatorKeyCombinationDirective,
    PaginatorNavigationDirective,
    IconClickShortcutDirective,
    FocusOnShortcutDirective,
    AccordionExpandCollapseDirective,
    TabShortcutDirective,
    OpenPopupShortcutDirective,
    OpenDetailsShortcutDirective,
    HawbShortcutDirective,
    SortShortcutDirective,
    TabNoOnlyShortcutDirective,
    ApArChargeGridAddShortcutDirective,
    AppEnterSubmitDirective,
  ],
  exports: [
    FocusOnEscapeDirective,
    TabFocusOnIndividualCheckboxDirective,
    TableFocusCheckboxShortcutDirective,
    PaginatorKeyCombinationDirective,
    PaginatorNavigationDirective,
    IconClickShortcutDirective,
    FocusOnShortcutDirective,
    AccordionExpandCollapseDirective,
    TabShortcutDirective,
    OpenPopupShortcutDirective,
    OpenDetailsShortcutDirective,
    HawbShortcutDirective,
    SortShortcutDirective,
    TabNoOnlyShortcutDirective,
    ApArChargeGridAddShortcutDirective,
    AppEnterSubmitDirective,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: initPaginatorArrowWindowCapture,
      deps: [PaginatorArrowWindowRegistryService],
    },
  ],
})
export class KeyStrokeDirectivesModule {}
